import {
  IGetPropertiesDTO,
  IGetPropertiesResponse,
  staticPropertyEndpoints,
  IGetPropertyResponse,
  getPropertiesEndpoints,
} from '@/models/property.model';
import { ApiResponse, httpClient } from '@/utils';

class PropertyAPI {
  static getProperties(data: IGetPropertiesDTO, isSold = false): ApiResponse<IGetPropertiesResponse> {
    const endpoint = isSold ? staticPropertyEndpoints.GET_PROPERTIES_SOLD : staticPropertyEndpoints.GET_PROPERTIES;
    return httpClient.get<IGetPropertiesResponse>(endpoint, { params: data });
  }

  static getProperty(id: string): ApiResponse<IGetPropertyResponse> {
    const { GET_PROPERTY } = getPropertiesEndpoints({ propertyId: id });
    return httpClient.get<IGetPropertyResponse>(GET_PROPERTY);
  }
}

export default PropertyAPI;
